// Module
var code = "<select id=\"{{vm.name}}\" class=\"form-control input-sm\" tabindex=\"-1\" ng-model=\"vm.model\" ng-options=\"item.key as item.value|translate for item in vm.levels\" name=\"{{vm.name}}\" ng-class=\"{'disable': vm.isDisabled}\"> </select>";
// Exports
module.exports = code;